import { api } from '@/lib/api';

export interface SendVerificationEmailData {
  message: string;
  email: string;
}

export interface VerifyEmailTokenData {
  message: string;
  verified: boolean;
}

export async function sendVerificationEmail(): Promise<SendVerificationEmailData> {
  const response = await api.post<SendVerificationEmailData>('auth/verify-email');

  if (!response.success || !response.data) {
    throw new Error(response.error?.message || 'Failed to send verification email');
  }

  return response.data;
}

export async function resendVerificationEmail(): Promise<SendVerificationEmailData> {
  return sendVerificationEmail();
}

export async function verifyEmailToken(token: string, type?: string): Promise<VerifyEmailTokenData> {
  const response = await api.post<VerifyEmailTokenData>('auth/verify', {
    token,
    ...(type ? { type } : {})
  });

  if (!response.success || !response.data) {
    throw new Error(response.error?.message || 'Failed to verify email token');
  }

  return response.data;
}
